import {CommentListResultVo} from '../../common/shared/api/nicolas/vo/comment/CommentListResultVo.interface';
import {CommentList} from '../generated/types';
import {createCommentItem} from './CommentItem';
import {createSortOption} from './SortOption';

export function createCommentList(
  commentListResult: CommentListResultVo
): CommentList {
  return {
    commentList: commentListResult.comment_list?.map(createCommentItem) || [],
    isEnd: commentListResult.is_end ?? true,
    totalCount: commentListResult.total_count ?? 0,
    bestTotalCount: commentListResult.best_total_count ?? 0,
    selectedSortOpt: commentListResult.selected_sort_opt
      ? createSortOption({
          sortOptVo: commentListResult.selected_sort_opt,
        })
      : undefined,
    sortOptList: commentListResult.sort_opt_list
      ? commentListResult.sort_opt_list.map(opt =>
          createSortOption({sortOptVo: opt})
        )
      : undefined,
  };
}
